import { Navigate, Outlet, useLocation } from "react-router-dom";
import useWrapper from "../../hooks/useWrapper";


export default function RequireAuthFormando() {
  const { me } = useWrapper();

  const location = useLocation();
  return (
    me?.type === "Formando" ? <Outlet /> :
      me?.type === "Gestor" ? <Navigate to="/" state={{ from: location }} replace /> :
        <Navigate to="/formando" state={{ from: location }} replace />
  )
}
